package com.essntl.core.unsplash.data.response

import kotlinx.serialization.Serializable

@Serializable
internal data class UnsplashResponse(
    val results: List<PictureDto>,
)
